module.exports = __webpack_public_path__ + "static/media/firstScreenBg.e68eec01.svg";